"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var R = _interopRequireWildcard(require("ramda"));
var _downshift = _interopRequireDefault(require("downshift"));
var _handlers = require("../../../../helpers/handlers");
var _config = require("../../../../services/config");
var _Checkbox = _interopRequireDefault(require("../../../ui/Checkbox"));
var _Button = _interopRequireWildcard(require("../../../ui/Button"));
var _Label = _interopRequireDefault(require("../../../ui/Label"));
var _close = _interopRequireDefault(require("../../../Modal/Modal/img/close.svg"));
var _withProps = _interopRequireDefault(require("./withProps"));
var _styles = _interopRequireDefault(require("./styles"));
var _excluded = ["getBackground"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var getExternalProps = function getExternalProps(isActive) {
  return R.call(R.ifElse(Boolean, function (_ref) {
    var getBackground = _ref.getBackground,
      externalProps = _objectWithoutProperties(_ref, _excluded);
    return _objectSpread({}, externalProps, {
      background: getBackground(isActive)
    });
  }, R.always({})), (0, _config.getServicesControlInSearchForm)());
};
var ServicesControl = function ServicesControl(_ref2) {
  var favoritServices = _ref2.favoritServices,
    services = _ref2.services,
    servicesByCountryID = _ref2.servicesByCountryID,
    initialSelectedServices = _ref2.selectedServices,
    onApply = _ref2.onApply,
    onReset = _ref2.onReset,
    onToggle = _ref2.onToggle;
  var _useTranslation = (0, _reactI18next.useTranslation)('SEARCH_FORM'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(initialSelectedServices),
    _useState2 = _slicedToArray(_useState, 2),
    selectedServices = _useState2[0],
    setSelectedServices = _useState2[1];
  var handleToggleServices = function handleToggleServices(service) {
    return setSelectedServices(R.includes(service, selectedServices) ? R.without([service], selectedServices) : R.append(service, selectedServices));
  };
  var handleReset = function handleReset() {
    return onReset(), setSelectedServices([]);
  };
  (0, _react.useEffect)(function () {
    if (R.isEmpty(initialSelectedServices)) {
      setSelectedServices(function (prevSelected) {
        return R.isEmpty(prevSelected) ? prevSelected : [];
      });
    }
  }, [initialSelectedServices]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Label.default, {
    clickable: false,
    text: t('SERVICES_CONTROL_LABEL')
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _styles.default.checkboxes
  }, R.map(function (_ref3) {
    var label = _ref3.label,
      icon = _ref3.icon,
      service = _ref3.service;
    var isActive = R.includes(service, initialSelectedServices);
    return /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
      icon: icon,
      key: label,
      size: _Button.SIZES.TINY,
      theme: isActive ? _Button.THEMES.PURPLE : _Button.THEMES.GRAY,
      onClick: function onClick() {
        return onToggle(service);
      }
    }, getExternalProps(isActive)), label);
  }, favoritServices), /*#__PURE__*/_react.default.createElement(_downshift.default, {
    onOuterClick: function onOuterClick() {
      return setSelectedServices([]);
    }
  }, function (_ref4) {
    var closeMenu = _ref4.closeMenu,
      isOpen = _ref4.isOpen,
      toggleMenu = _ref4.toggleMenu;
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Button.default, {
      size: _Button.SIZES.TINY,
      onClick: function onClick() {
        return toggleMenu(), !isOpen && setSelectedServices(initialSelectedServices);
      }
    }, t('OPEN_SERVICES_POPUP_BUTTON')), isOpen && /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.modalBody
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.modalCloseWrapper
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      theme: _Button.THEMES.TRANSPARENT,
      activeTheme: _Button.THEMES.PURPLE,
      className: _styles.default.closeIcon,
      icon: _close.default,
      onClick: closeMenu
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.servicesBlocks
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.servicesBlock
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.servicesTitle
    }, t('RECOMMEND_SERVICES_TITLE')), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.servicesList
    }, R.map(function (_ref5) {
      var label = _ref5.label,
        service = _ref5.service;
      var isChecked = R.includes(service, selectedServices);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.servicesItem,
        key: label
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        withBackground: true,
        checked: isChecked,
        label: label,
        onChange: function onChange() {
          return handleToggleServices(service);
        }
      }));
    }, servicesByCountryID))), R.map(function (_ref6) {
      var label = _ref6.label,
        group = _ref6.group;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.servicesBlock,
        key: label
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.servicesTitle
      }, label), /*#__PURE__*/_react.default.createElement("div", {
        className: _styles.default.servicesList
      }, R.map(function (item) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: _styles.default.servicesItem,
          key: item.label
        }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          withBackground: true,
          checked: R.includes(item.service, selectedServices),
          label: item.label,
          onChange: function onChange() {
            return handleToggleServices(item.service);
          }
        }));
      }, group)));
    }, services)), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.servicesButtons
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      theme: _Button.THEMES.PURPLE,
      onClick: (0, _handlers.handleWith)(function () {
        return onApply(selectedServices);
      }, closeMenu)
    }, t('APPROVE_SERVICES_POPUP_BUTTON')), /*#__PURE__*/_react.default.createElement(_Button.default, {
      theme: _Button.THEMES.GRAY,
      onClick: (0, _handlers.handleWith)(handleReset, closeMenu)
    }, t('RESET_SERVICES_POPUP_BUTTON')))));
  })));
};
var enhancer = R.compose(_withProps.default, _react.memo);
var _default = exports.default = enhancer(ServicesControl);